import type { ReactNode } from 'react';
import type { TabProductMap } from 'reactApp/sections/QuotaLanding/MultiTariffsList/hooks/useUpsaleProductsMapping';
import type { Product } from 'reactApp/types/Billing';
import type { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

export interface MultiTariffUpsaleModelType {
    getTitle(): ReactNode;
    getTitleDescription(): ReactNode;
    getPriorityCardTopTitle(): ReactNode;
    getPriorityCardTitle(): ReactNode;
    getPriorityCardDescription(): ReactNode;
    getPriorityCardLabelText(): ReactNode;
    getSecondaryCardTopTitle(): ReactNode;
    getSecondaryCardTitle(): ReactNode;
    getSecondaryCardDescription(): ReactNode;
    getSecondaryCardLabelText(): ReactNode;
    getSecondaryCardLabelVisible(): boolean;
    getDwh(selected: MultiTariffUpsaleRadioType): object & { action: string };
    getSecondProduct(): Product;
    getUpsaleProduct(): Product | undefined;
}
export interface MultiTariffUpsaleArgs {
    activeTab: ETabsName;
    product: Product;
    tabProductMap: TabProductMap;
}

export const enum MultiTariffUpsaleRadioType {
    priority = 'priority',
    second = 'second',
}
